import { createContext } from 'react';

import { PopupContextValue } from './types';

export const PopupContext = createContext<PopupContextValue>({
  popupController: null,
});
